import React from 'react';
import { Table, Button } from 'antd';
import CsvDownload from './CsvDownload';
import branding from '../data/branding';
import {getFormatTotal, getTotalOfObject, getPercentageOfObject, mergeObjectToArray, setUpColumnObject} from '../utils/utils';
import numeral from 'numeral';
import { groupReturnedObject} from '../chart/config';

class DetailTable extends React.Component {
  state = {
    sortedInfo: null,
  };

  handleChange = (pagination, filters, sorter) => {
    //console.log('Various parameters', pagination, filters, sorter);
    this.setState({
      sortedInfo: sorter,
    });
  }

  clearAll = () => {
    this.setState({
      sortedInfo: null,
    });
  }

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const firstItem = this.props.data[0];
    const tableName= `${branding}_${firstItem.geo_name}_${firstItem.category}`
    const percentageColumn = Object.keys(this.props.percentageObj).map(item => {
      return setUpColumnObject(`${item} (%)`, item, sortedInfo, false, 200)
    })
    //console.log('percentageColumn', percentageColumn)

    let tableMainData = [
      setUpColumnObject(this.props.data_table.display_name, 'category', sortedInfo, true, 220),
      setUpColumnObject(this.props.population, 'total', sortedInfo, false, 200)
    ]
    if(this.props.data_table.show_table_percentage === 1 || this.props.data_table.show_table_percentage === true) {
      tableMainData.push(setUpColumnObject(`${this.props.geo_name} (%)`, 'percentage', sortedInfo, false, 200),)
    }
    
    let columns = [{
      title: (<div className="heading-container">
        <h3>Data for {firstItem.geo_name} </h3>
        <CsvDownload data={this.props.data}  tableName={tableName} />
        </div>),
        children: tableMainData
      }
    ];
    if(this.props.data_table.show_table_comparisons === 1 || this.props.data_table.show_table_comparisons === true) {
      columns.push( 
        {
        title: (<h3>Compared with:</h3>),
        children: [
          ...percentageColumn
        ]
      }
    )
    }
    return (
      <div className="table">
        <Table scroll={{ y: 400 }} 
        bordered={true} pagination={false} rowKey={record => record.id} columns={columns} 
        dataSource={this.props.dataMergedForTable} onChange={this.handleChange} />
      </div>
    );
  }
}

export default DetailTable;


// WEBPACK FOOTER //
// ./src/components/DetailTable.js